export const helperStore = {
  state: {
    topics: [
      {
        value: "createPreparationSlip",
        text: "Créer un bon de préparation",
        md: "PreparationSlip",
        action: { type: "router", value: "PreparationSlipEditor" },
        admin: false
      },
      {
        value: "viewPreparationSlip",
        text: "Afficher/Trouver un bon de préparation",
        md: "PreparationSlip",
        action: { type: "router", value: "PreparationSlipIndex" },
        admin: false
      },
      {
        value: "printPreparationSlip",
        text: "Imprimer un bon de préparation",
        md: "PreparationSlip",
        action: { type: "router", value: "PreparationSlipIndex" },
        admin: false
      },
      {
        value: "createPreparationSlipTemplate",
        text: "Créer un gabarit de bon de préparation",
        md: "PreparationSlip",
        action: { type: "router", value: "PreparationSlipTemplateEditor" },
        admin: true
      },
      {
        value: "editPreparationSlipTemplate",
        text: "Modifier/Trouver un gabarit de bon de préparation",
        md: "PreparationSlip",
        action: { type: "router", value: "PreparationSlipIndex" },
        admin: true
      },
      {
        value: "setDefaultPreparationSlipTemplate",
        text: "Configurer un gabarit de bon de préparation par défaut",
        md: "PreparationSlip",
        action: { type: "component", value: "DefaultDailyPrepSlipEditor" },
        admin: true
      },
      {
        value: "createDeliverySlip",
        text: "Créer un bon de livraison/commande",
        action: { type: "router", value: "DeliverySlipCreator" },
        admin: false,
        md: "DeliverySlip"
      },
      {
        value: "findDeliverySlip",
        text: "Trouver un bon de livraison/commande en cours",
        action: { type: "router", value: "DeliverySlipIndex" },
        admin: false,
        md: "DeliverySlip"
      },
      {
        value: "receiveDelivery",
        text: "Recevoir une commande",
        action: { type: "router", value: "DeliverySlipIndex" },
        admin: false,
        md: "DeliverySlip"
      },
      {
        value: "createDeliverySlipTemplate",
        text: "Créer un gabarit de bon de livraison/commande",
        action: { type: "router", value: "OrderTemplateEditor" },
        admin: true,
        md: "DeliverySlip"
      },
      {
        value: "editDeliverySlipTemplate",
        text: "Modifier/Trouver un gabarit de bon de livraison/commande",
        action: { type: "router", value: "OrderTemplateIndex" },
        admin: true,
        md: "DeliverySlip"
      },
      {
        value: "createAutomaticPrepSlip",
        text: "Créer une production/préparation automatisée",
        action: { type: "component", value: "AutomaticPrepSlipEditor" },
        admin: true
      },
      {
        value: "createAutomaticPrepSlip",
        text: "Trouver/Modifier une production/préparation automatisée",
        action: { type: "router", value: "AutomaticPrepSlipIndex" },
        admin: true
      },
      {
        value: "createScheduledProduction",
        text: "Planifier une production/préparation future",
        action: { type: "component", value: "ScheduledPrepEditor" },
        admin: true
      },
      {
        value: "createRecipe",
        text: "Créer une recette",
        action: { type: "method", value: "createRecipe" },
        admin: true,
        md: "Recipe"
      },
      {
        value: "editRecipe",
        text: "Modifier/Trouver une recette",
        action: { type: "router", value: "RecipeIndex" },
        admin: false,
        md: "Recipe"
      },
      {
        value: "editRecipe",
        text: "Copier une recette",
        action: { type: "router", value: "RecipeIndex" },
        admin: false,
        md: "Recipe"
      },
      {
        value: "editRecipe",
        text: "Imprimer une recette",
        action: { type: "router", value: "RecipeIndex" },
        admin: false,
        md: "Recipe"
      },
      {
        value: "createProduct",
        text: "Créer un produit",
        action: {
          type: "router",
          value: "ProductCreator"
        },
        md: "Product",
        admin: true
      },
      {
        value: "editProduct",
        text: "Modifier/Trouver un produit",
        action: {
          type: "router",
          value: "RecipeProductsIndex"
        },
        md: "Product",
        admin: false
      },
      {
        value: "findInventory",
        text: "Consulter/Voir l'inventaire",
        action: { type: "router", value: "InventoryIndex" },
        admin: false,
        md: "Inventory"
      },
      {
        value: "takeInventory",
        text: "Prise d'inventaire/Prendre l'inventaire",
        action: { type: "router", value: "InventoryIndex" },
        admin: false,
        md: "Inventory"
      },
      {
        value: "createWasteCause",
        text: "Créer une cause de perte",
        action: { type: "method", value: "createWasteCause" },
        admin: true
      },
      {
        value: "editWasteCause",
        text: "Modifier/Trouver une cause de perte",
        action: { type: "router", value: "InventoryWasteCauseIndex" },
        admin: true
      },
      {
        value: "addProduction",
        text: "Ajouter/Retirer une production/préparation",
        action: {
          type: "component",
          value: "ProductionDialog"
        },
        md: "ProductionAndWaste",
        admin: false
      },
      {
        value: "addWaste",
        text: "Ajouter/Rentrer une perte",
        action: {
          type: "component",
          value: "InventoryWasteDialog"
        },
        md: "ProductionAndWaste",
        admin: false
      },
      {
        value: "createSale",
        text: "Créer une vente",
        action: { type: "component", value: "SalesAdder" },
        admin: false
      },
      {
        value: "findSale",
        text: "Consulter les ventes/l'analytique",
        action: { type: "router", value: "AnalyticIndex" },
        admin: false
      },
      {
        value: "createSupplier",
        text: "Créer/Ajouter un fournisseur",
        action: {
          type: "router",
          value: "SuppliersEditor"
        },
        admin: true,
        md: "Supplier"
      },
      {
        value: "editSupplier",
        text: "Modifier/Trouver un fournisseur",
        action: {
          type: "router",
          value: "SuppliersIndex"
        },
        admin: true,
        md: "Supplier"
      },
      {
        value: "editTag",
        text: "Configurer ou modifier les catégories de mots clés / hashtag(#)",
        action: {
          type: "router",
          value: "TagManagerIndex"
        },
        admin: true,
        md: "TagManager"
      },
      {
        value: "editTag",
        text: "Configurer les mots clés / hashtag(#)",
        action: {
          type: "router",
          value: "TagManagerIndex"
        },
        admin: true,
        md: "TagManager"
      },
      {
        value: "editTag",
        text: "Gestion des mots clés / hashtag(#)",
        action: {
          type: "router",
          value: "TagManagerIndex"
        },
        admin: true,
        md: "TagManager"
      },
      {
        value: "createCustomUnit",
        text: "Créer une unité personalisée",
        action: {
          type: "component",
          value: "CustomUnitAdder"
        },
        admin: true,
        md: "UnitManager"
      },
      {
        value: "createCustomFormat",
        text: "Créer un format personalisé",
        action: {
          type: "component",
          value: "CustomUnitAdder"
        },
        admin: true,
        md: "UnitManager"
      },
      {
        value: "editCustomUnit",
        text: "Modifier/Trouver les unités personalisées",
        action: {
          type: "router",
          value: "CustomUnitIndex"
        },
        admin: true,
        md: "UnitManager"
      },
      {
        value: "editCustomFormat",
        text: "Modifier/Trouver les formats personalisées",
        action: {
          type: "router",
          value: "CustomUnitIndex"
        },
        admin: true,
        md: "UnitManager"
      },
      {
        value: "sendSalesReport",
        text: "Envoyer rapport de ventilation",
        action: {
          type: "component",
          value: "ReportSender"
        },
        admin: false
      },
      {
        value: "connectAdmin",
        text: "Passer en mode administrateur",
        action: {
          type: "component",
          value: "UserAdminLogin"
        },
        admin: false,
        md: "Admin"
      },
      {
        value: "connectAdmin",
        text: "Changer le mot de passe",
        action: {
          type: "component",
          value: "UserAdminLogin"
        },
        admin: true,
        md: "Admin"
      },
      {
        value: "connectAdmin",
        text: "Changer le nom d'utilisateur",
        action: {
          type: "component",
          value: "UserAdminLogin"
        },
        admin: true,
        md: "Admin"
      }
    ]
  },
  getters: {
    getHelperTopics(state) {
      return state.topics;
    }
  }
};
